var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4672 21.2239C16.997 21.557 16.3776 21.5914 15.8735 21.3123L11 18.6145L6.12648 21.3123C5.62237 21.5914 5.00297 21.557 4.53282 21.2239C4.06267 20.8908 3.82489 20.3178 3.92104 19.7497L4.89358 14.0029L0.927756 9.94894C0.535921 9.5484 0.400001 8.96286 0.575324 8.43066C0.750647 7.89847 1.20798 7.50836 1.76116 7.41914L7.18287 6.54467L9.64487 1.35688C9.89323 0.83355 10.4207 0.5 11 0.5C11.5793 0.5 12.1068 0.83355 12.3551 1.35688L14.8107 6.53099L20.2155 7.31556C20.7713 7.39625 21.2355 7.78072 21.4183 8.31183C21.6011 8.84293 21.4719 9.43165 21.0835 9.83736L17.1047 13.9929L18.079 19.7497C18.1751 20.3178 17.9373 20.8908 17.4672 21.2239ZM13.8 7.9L11 2L8.2 7.9L2.00001 8.9L6.50001 13.5L5.40001 20L11 16.9L16.6 20L15.5 13.5L20 8.8L13.8 7.9Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.2213d50374fec880018f34c7e8664a34.svg";
export { ForwardRef as ReactComponent };